import { Action } from '@ngrx/store';
import { IRegistrationEvent } from '../../models/registrationevent.model';

export enum RegistrationEventActionType {
    FETCH_REGISTRATIONEVENTS = '[RegistrationEvent] Fetch RegistrationEvents',
    ADD_REGISTRATIONEVENT = '[RegistrationEvent] Add RegistrationEvent',
    SET_REGISTRATIONEVENT_TO_COMPLETE = '[RegistrationEvent] Set RegistrationEvent To Complete',
    DELETE_REGISTRATIONEVENT = '[RegistrationEvent] Delete RegistrationEvent',
}

export class FetchRegistrationEventAction implements Action {
    readonly type = RegistrationEventActionType.FETCH_REGISTRATIONEVENTS;
    constructor(public registrationEvents: IRegistrationEvent[]) {
      //  console.log("registrationEvents" + JSON.stringify(registrationEvents));
     }
}

export class AddRegistrationEventAction implements Action {
    readonly type = RegistrationEventActionType.ADD_REGISTRATIONEVENT;
    constructor(public registrationEvent: IRegistrationEvent) { 
       // console.log("registrationEvent" + JSON.stringify(registrationEvent));
    }
}

export class SetRegistrationEventToCompleteAction implements Action {
    readonly type = RegistrationEventActionType.SET_REGISTRATIONEVENT_TO_COMPLETE;
    constructor(public id: number) { }
}

export class DeleteRegistrationEventAction implements Action {
    readonly type = RegistrationEventActionType.DELETE_REGISTRATIONEVENT;
    constructor(public id: number) { }
}

export type RegistrationEventAction = FetchRegistrationEventAction
    | AddRegistrationEventAction
    | SetRegistrationEventToCompleteAction
    | DeleteRegistrationEventAction;